export const path = {
  languageSettings: {
    route: "/language-settings",
    link: () => path.languageSettings.route,
  },
};
